<template>
    <div style="margin-top:10px; margin-bottom:20px; display: inline-block">
        <v-progress-circular
        indeterminate
        color="#00a3dd"
        ></v-progress-circular>
    </div>
</template>

<script>

export default {
  name: "loader"
};
</script>

<style>
@import "../assets/css/Messagerie.css"; 
</style>